import { GOAL_FAIL, GOALS_SHOW, GOALS_FETCH, GOALS_REQUEST, GOAL_EDIT, GOAL_DELETE, GOAL_ACTIVITIES, GOAL_COMPLETE, GOAL_CLEAR } from "../store/config";

const goalInit = {
	isFetching: false,
	list: [],
	pages: {
		current: undefined,
		per_page: undefined,
		total: undefined
	},
	filters: {
		q:'',
		type: '',
		modality_id: '',
		state_id: ''
	},
	edit: {
		activities:[]
	},
	permissions: [],
	error: undefined,
	message: null
};

const goals = (state = goalInit, action) => {
	switch(action.type) {
		case GOALS_REQUEST:
			return {
				...state,
				isFetching: action.isFetching,
				timestamp: action.timestamp
			}
		case GOALS_SHOW:
			return {
				...state,
				isFetching: action.isFetching,
				list: action.payload,
				pages: action.pages,
				permissions: action.permissions,
				timestamp: action.timestamp
			}
		case GOALS_FETCH:
			return {
				...state,
				isFetching: action.isFetching,
				list: action.payload,
				timestamp: action.timestamp
			}
		case GOAL_EDIT:
			return {
				...state,
				edit: {
					...state.edit,
					...action.payload
				},
				permissions: action.permissions,
				timestamp: action.timestamp
			}
		case GOAL_ACTIVITIES:
			return {
				...state,
				edit: {
					...state.edit,
					activities: action.payload
				},
				timestamp: action.timestamp
			}
		case GOAL_COMPLETE:
			return {
				...state,
				isFetching: action.isFetching,
				timestamp: action.timestamp
			}
		case GOAL_DELETE:
			return {
				...state,
				isFetching: action.isFetching,
				timestamp: action.timestamp
			}
		case GOAL_CLEAR:
			return {
				...state,
				edit: action.payload,
				timestamp: action.timestamp
			}
		case GOAL_FAIL:
			return {
				...state,
				isFetching: action.isFetching,
				error: action.error,
				timestamp: action.timestamp
			}
		default:
			return {
				...state
			}
	}
}

export default goals;


// WEBPACK FOOTER //
// ./src/reducers/goals.js